import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-20 bg-stone-50" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-3">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-lg shadow-md border-t-4 border-green-500" data-id="element-4">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-5">
              <span className="bg-green-100 text-green-700 p-1 rounded" data-id="element-6">
                ✔
              </span>
              Este libro es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-7">
              {['estás en un momento de replanteo', 'sentís desgaste emocional', 'necesitás palabras que ordenen', 'querés entenderte mejor'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-700" data-id="element-8">
                  <Check className="text-green-500 w-5 h-5 mt-0.5 flex-shrink-0" data-id="element-9" />
                  <span data-id="element-10">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-8 rounded-lg shadow-md border-t-4 border-red-500" data-id="element-11">
            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-12">
              <span className="bg-red-100 text-red-700 p-1 rounded" data-id="element-13">✖</span>
              No es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-14">
              {['buscás fórmulas mágicas', 'querés que alguien te diga qué hacer', 'no estás dispuesto a mirar hacia adentro'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-700" data-id="element-15">
                  <X className="text-red-500 w-5 h-5 mt-0.5 flex-shrink-0" data-id="element-16" />
                  <span data-id="element-17">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}